export default {
  TODO: 'todo',
  SUBSTEP: 'substep',
};



// WEBPACK FOOTER //
// ./src/ItemTypes.js